import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            51吃瓜爆料网实时快讯，不错过任何一个劲爆大瓜
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative">
          <div className="absolute left-5 top-0 bottom-0 w-0.5 bg-background-300 hidden sm:block"></div>

          <div className="space-y-6">
            {updates.map((item, idx) => (
              <div key={item.id} className="relative flex gap-5 pl-0 sm:pl-14">
                <div className="hidden sm:flex absolute left-4 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10 -translate-x-1/2 mt-1.5"></div>

                <div className="flex-1 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70">
                  <div className="flex flex-wrap items-center gap-3 mb-2">
                    <span className="inline-flex px-2.5 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">
                      {item.date} {item.time}
                    </span>
                    {idx === 0 && (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary-100 text-primary-600 text-xs font-medium">
                        <i className="ri-fire-line"></i>
                        最新
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}